var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "mb-5" },
    [
      _c(
        "FormulateForm",
        {
          ref: "formFiscalTaxParameter",
          attrs: {
            name: "formFiscalTaxParameter",
            model: _vm.fiscalTaxParameter,
          },
          on: { submit: _vm.saveFiscalTaxParameter },
        },
        [
          _c(
            "b-card-actions",
            {
              attrs: {
                "action-collapse": "",
                title: _vm.$t("Informações Gerais"),
                "show-loading": _vm.isLoading,
              },
            },
            [
              _c("fiscal-tax-parameter-form", {
                attrs: { busy: _vm.isLoading },
              }),
            ],
            1
          ),
          _c("transition", { attrs: { name: "slide" } }, [
            _vm.fiscalTaxParameter.ratesVisible
              ? _c(
                  "div",
                  [
                    _c(
                      "b-card-actions",
                      {
                        attrs: {
                          "action-collapse": "",
                          title: _vm.$t("CBS"),
                          "show-loading": _vm.isLoading,
                        },
                      },
                      [_c("fiscal-tax-parameter-cbs-form")],
                      1
                    ),
                    _c(
                      "b-card-actions",
                      {
                        attrs: {
                          "action-collapse": "",
                          title: _vm.$t("IBS"),
                          "show-loading": _vm.isLoading,
                        },
                      },
                      [_c("fiscal-tax-parameter-ibs-form")],
                      1
                    ),
                    _c(
                      "b-card-actions",
                      {
                        attrs: {
                          "action-collapse": "",
                          title: _vm.$t("Vigências de alíquotas"),
                        },
                      },
                      [_c("fiscal-tax-parameter-rate-history")],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          false
            ? _c(
                "b-card-actions",
                {
                  attrs: {
                    "action-collapse": "",
                    title: _vm.$t("Imposto Seletivo"),
                    "show-loading": _vm.isLoading,
                  },
                },
                [
                  _c("fiscal-tax-parameter-selective-tax-form", {
                    attrs: { busy: _vm.isLoading },
                  }),
                ],
                1
              )
            : _vm._e(),
          false
            ? _c(
                "b-card-actions",
                {
                  attrs: {
                    "action-collapse": "",
                    title: _vm.$t("Regras de Destino"),
                    "show-loading": _vm.isLoading,
                  },
                },
                [_c("fiscal-tax-parameter-special-treatment-form")],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("e-crud-actions", {
        attrs: { busy: _vm.isLoading },
        on: { save: _vm.saveFiscalTaxParameter, cancel: _vm.cancelHandle },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }